import { PhoneNumberUtil } from "google-libphonenumber";

export const phoneNumberUtil = PhoneNumberUtil.getInstance();
